import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import { getTransactionsPendingApprovalAsync } from '../../../../../store/slices/transactionMandateV2/getPendingTransactionsSlice';

const SHOW_ON_ROUTES = ['/app/dashboard'];

export default function useTransactionsApprovalPrompt() {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { status, value } = useAppSelector(
    (state) => state.getTransactionsPendingApproval,
  );

  const businessId = localStorage.getItem('businessId');

  useEffect(() => {
    if (businessId) {
      dispatch(getTransactionsPendingApprovalAsync({}));
    }
  }, [dispatch, businessId]);

  const showBanner =
    status === 'success' &&
    Boolean(value?.data?.length) &&
    SHOW_ON_ROUTES.some((route) => location.pathname.includes(route));

  return { showBanner };
}
